enum ActionTypes {
  GetMerchantDetails = 'GetMerchantDetails',
  GetMerchantsPage = 'GetMerchantsPage',
  SetLocation = 'SetLocation',
  GuestSignIn = 'GuestSignIn',
  CartInfo = 'CartInfo',
  AddCart = 'AddCart',
  EditCart = 'EditCart',
  EmptyCart = 'EmptyCart',
  RemoveCartItem = 'RemoveCartItem',
  AddCartTip = 'AddCartTip',
  RemoveCartTip = 'RemoveCartTip',
  Checkout = 'Checkout',
  SetInfoPopupOpen = 'SetInfoPopupOpen',
  SetSearchMethod = 'SetSearchMethod',
  SetSearchFilter = 'SetSearchFilter',
  SetShopFilter = 'SetShopFilter',
  SetCurbsideData = 'SetCurbsideData',
  SaveCurbsideData = 'SaveCurbsideData',
  GetOrderReceipt = 'GetOrderReceipt',
  SetPickupDateTime = 'SetPickupDateTime',
}

export default ActionTypes;
